module.exports = __webpack_public_path__ + "img/etoro-dark.0404a22a.png";